module.exports = __webpack_public_path__ + "static/media/icon-chevron.ced01235.svg";